import React from 'react';

// Predefined list of categories
const CATEGORIES = [
  'Politics',
  'Business',
  'Technology',
  'Science',
  'Health',
  'Arts',
  'Sports',
  'Opinion',
  'World',
  'Lifestyle'
];

export default function CategorySelect({ selectedCategories, onChange }) {
  const handleCategoryClick = (category) => {
    if (selectedCategories.includes(category)) {
      onChange(selectedCategories.filter(c => c !== category));
    } else {
      onChange([...selectedCategories, category]);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {CATEGORIES.map(category => (
          <button
            key={category}
            type="button"
            onClick={() => handleCategoryClick(category)}
            className={`px-3 py-1 text-sm rounded-full border ${
              selectedCategories.includes(category)
                ? 'bg-taupe text-white border-taupe'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
            }`}
          >
            {category}
          </button>
        ))}
      </div>
      {selectedCategories.length > 0 && (
        <div className="text-sm text-gray-500">
          Selected: {selectedCategories.join(', ')}
        </div>
      )}
    </div>
  );
}